// extracted by mini-css-extract-plugin
export default {"switch":"ModesSwitch_switch__72+2f","creatorViewContainer":"ModesSwitch_creatorViewContainer__zojj1","hoverState":"ModesSwitch_hoverState__cVvv9"};